import { Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ConexionService {
  private estadoConexion = new BehaviorSubject<boolean>(navigator.onLine);
  // eslint-disable-next-line @typescript-eslint/member-ordering
  estadoConexion$ = this.estadoConexion.asObservable();

  constructor() {
    // Escucha cuando la conexión se pierde
    fromEvent(window, 'offline')
      .pipe(debounceTime(100))
      .subscribe(() => {
        this.estadoConexion.next(false);
      });

    // Escucha cuando la conexión regresa
    fromEvent(window, 'online')
      .pipe(debounceTime(100))
      .subscribe(() => {
        this.estadoConexion.next(true);
      });
  }
}
